import useAppLanguage from "@/components/Root/hooks/useAppLanguage";
import useCountryCode from "@/components/Root/hooks/useCountryCode";
import usePricingDisplayData from "@/components/Root/hooks/usePricingDisplayData";
import useRouteHandle from "@/components/Root/hooks/useRouteHandle";
import UILoader from "@/components/ui/Loader";
import useControlIntercom from "@/hooks/useHideIntercom";
import { Outlet } from "@/lib/router";
import { usePageTracking } from "@/tracking/usePageTracking";
import { useSigninCheck } from "reactfire";

export const PublicLayout = () => {
  const { status } = useSigninCheck();
  const { hideIntercom } = useRouteHandle();

  useControlIntercom(hideIntercom === true);
  usePageTracking();
  useCountryCode();
  useAppLanguage();
  usePricingDisplayData();
  // useV1Redirect();

  if (status === "loading") {
    return <UILoader />;
  }

  return <Outlet />;
};
